// File History
export const FILE_TEMPORARY_DAY_COUNT: number = 7;
export const BASIC_EXCEL_EXPORT_DATA_MAX_SIZE: number = 100;

export const MAX_VALUE_LENGTH_FOR_SIMPLE_FORMATTING = 1000000;

//CURRENCY
export const CurrencyList = [{ label: 'TRY', value: 'TRY' }];
export const SearchCurrencyList = [{ label: 'Seçiniz', value: null }, ...CurrencyList];

export const currencyOptions = [
	{
		label: 'null',
		value: 'none',
	},
	{
		label: '₺',
		value: 'TRY',
	},
	{
		label: '$',
		value: 'USD',
	},
	{
		label: '€',
		value: 'EUR',
	},
];

export const defaultGeneralSettings = {
	fontSize: '12px',
	fontStyle: 'Mulish, sans-serif',
};

export const chartAnimationIcons = [
	{
		icon: 'fa-solid fa-chart-column',
	},
	{
		icon: 'fa-solid fa-chart-area',
	},
	{
		icon: 'fa-solid fa-chart-pie',
	},
	{
		icon: 'fa-solid fa-chart-line',
	},
];
